/** @prettier */
import classNames from 'classnames';
import { Record } from 'immutable';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

import Button from '@xanadu/ui-shared/components/widgets/Button';
import { roundDownSmallValue } from '@xanadu/ui-shared/utils/numbers';

import Currency from '../../../containers/Currency';

import CloseBtn from '../../widgets/CloseBtn';

import styles from './BonusInfoModal.module.scss';

const BonusInfoModal = ({ bonus, ackBonusModal, onRequestClose, history }) => {
  const { expiry, imgUrl, termsAndConditionsUrl, wallet } = bonus || {};

  useEffect(() => {
    ackBonusModal(wallet.bonusWalletId);
  }, []);

  const mainClass = classNames({
    [styles.main]: true,
  });

  return (
    <div className={mainClass}>
      <CloseBtn onClick={onRequestClose} />
      <div className={styles.content}>
        <div className={styles.imageSection}>
          <img src={imgUrl} alt="bonus-img" />
        </div>
        <div className={styles.bonusTitle}>You have been awarded a Casino Bonus</div>
        <div className={styles.bonusAwarded}>
          You have received a {<Currency value={roundDownSmallValue(wallet.amount)} />} bonus to use
          in the Matchbook Casino.
        </div>
        <div className={styles.rowContainer}>
          <div className={styles.bonusInfo}>
            <div>Expires: {expiry}</div>
            <Link to={termsAndConditionsUrl} className={styles.termsAndConditions}>
              <span>Terms & Conditions</span>
            </Link>
          </div>
          <div className={styles.buttonContainer}>
            <Button
              sizeType="regular"
              buttonType="primary"
              className={styles.button}
              onClick={() => {
                onRequestClose();
                history.push('/casino/featured-games');
              }}
            >
              Play Now
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

BonusInfoModal.propTypes = {
  ackBonusModal: PropTypes.func.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  bonus: PropTypes.instanceOf(Record).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
};

export default BonusInfoModal;
